/** @format */

export * from './product-badge.module';
